import { mergeWith } from 'lodash'

const actionTypes = {
  SetExportData: 'exporter/SET_EXPORT_DATA',
  SetExportSort: 'exporter/SET_EXPORT_SORT',
  SetExportReportData: 'exporter/SET_EXPORT_REPORT_DATA',
}

const initialState = {
  outputs: [], // array of data outputs
  from: null, // pdf, what function to utilize via "STRING_TYPE" ie "DISCOVERY", "REPORTING" etc
  sort: null,
  report: null,
}

export const reducer = (state = initialState, action) => {
  const { type, ...payload } = action.payload || {}

  switch (action.type) {
    case actionTypes.SetExportData:
      return { ...state, ...action.payload.exportData }
    case actionTypes.SetExportSort:
      return { ...state, sort: action.payload }
    case actionTypes.SetExportReportData:
      return {
        ...state,
        from: type || null,
        sort: payload ? state.sort : null,
        report: payload
          ? mergeWith({}, state.report, payload, (objValue, srcValue) =>
              Array.isArray(objValue) ? srcValue : undefined,
            )
          : null,
      }
    default:
      return state
  }
}

export const actions = {
  setExportData: (exportData) => ({
    type: actionTypes.SetExportData,
    payload: { exportData },
  }),
  setExportSort: (payload) => ({
    payload,
    type: actionTypes.SetExportSort,
  }),
  setExportReportData: (payload) => ({
    payload,
    type: actionTypes.SetExportReportData,
  }),
}
